import { useRef, useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextRegular, TextSemiBold } from 'UiKit/typography';
import InputComponent from 'UiKit/input';
import ButtonOutline from 'UiKit/button/buttonOutline';
import ButtonSolid from 'UiKit/button/buttonSolid';
import usePostUserImage from 'Domain/brief-live/usePostUserImage';

import { NOTE_MAX_LENGTH } from '../const';
import ImageUploadBox from '../image-upload-box';

import styles from './styles.module.css';

const ProductCreatePanel = ({ onSave, onCancel }) => {
  const { t } = useTranslation('desktop-brief-live')
  const [label, setLabel] = useState('');
  const [sku, setSku] = useState('');
  const [note, setNote] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const [imageKey, setImageKey] = useState('');
  const fileInputRef = useRef(null);

  const { mutateAsync: uploadImage, isPending: isUploading } = usePostUserImage();

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const { imagePath, key } = await uploadImage({ file });
    setImagePreview(imagePath);
    setImageKey(key);
  };

  return (
    <Box className={styles['product-create__container']}>
      <Flex gap="16px">
        <ImageUploadBox imagePreview={imagePreview} fileInputRef={fileInputRef} onImageChange={handleImageChange} isUploading={isUploading} />
        <Box flex={1} display="flex" flexDirection="column" gap="8px">
          <Flex gap="8px">
            <Box flex={1}>
              <InputComponent
                placeholder={t('formTalkingPoint.productHighlightNamePlaceholderText')}
                value={label}
                onChange={(value) => setLabel(value)}
                className={styles['product-item__input-field']}
              />
            </Box>
            <Box width="200px">
              <InputComponent
                placeholder={t('formTalkingPoint.skuId')}
                value={sku}
                onChange={(value) => setSku(value)}
                className={styles['product-item__input-field']}
              />
            </Box>
          </Flex>
          <InputComponent
            placeholder={t('formTalkingPoint.notes')}
            value={note}
            onChange={(value) => setNote(value.slice(0, NOTE_MAX_LENGTH))}
            className={styles['product-item__input-field']}
          />
          <TextRegular className={styles['product-item__char-counter']}>
            ({note.length}/{NOTE_MAX_LENGTH})
          </TextRegular>
        </Box>
      </Flex>
      <Flex className={styles['product-item__edit-actions']}>
        <ButtonOutline height="28px" padding="6px 12px" borderRadius="var(--radius-sm)" type="button" onClick={onCancel}>
          <TextSemiBold fontSize="var(--font-body2)">{t('formTalkingPoint.cancelButton')}</TextSemiBold>
        </ButtonOutline>
        <ButtonSolid
          height="28px"
          padding="6px 12px"
          borderRadius="var(--radius-sm)"
          type="button"
          disabled={!label.trim() || isUploading}
          onClick={() =>
            onSave({
              label,
              value: sku || `manual_${Date.now()}`,
              note,
              imageKey: imageKey,
              image: imagePreview,
              isManual: true,
            })
          }
        >
          <TextSemiBold fontSize="var(--font-body2)" color="white">
            {t('formTalkingPoint.saveButton')}
          </TextSemiBold>
        </ButtonSolid>
      </Flex>
    </Box>
  );
};

export default ProductCreatePanel;
